<template>
    <div class="step-lista-imagem" style="height: 100%;">
        <div class="photo-box columns is-100" v-for="(img, i) in imagesPaginated" :key="i">
            <div class="column image-box">
                <div
                    class="image-as-background"
                    :style="{ 'background-image': 'url(\'' + img.imgurl + '\')' }"
                ></div>
                <p>{{ img.fileName }}</p>
            </div>
            <div class="extra-info-box">
                <div class="combo-box">
                    <vss-select
                        :id="generateId(1)"
                        title="produto"
                        placeholder="produto"
                        :value="img.produto"
                        :loading="produtoLoading"
                        :required="true"
                        :pageOptions="pageProdutoSelect"
                        :paginate="true"
                        @observer="loadProdutos"
                        :totalResults="paginationProduto.totalResults"
                        :invalid="img.produto == null"
                        @input="(e) => updateProdutos(i, e)"
                        label="nome"
                        tooltipLabel="info-catalogo-produto"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                        inForm
                        searchable
                        clearable
                    />
                </div>
                <div class="combo-box">
                    <vss-select
                        :id="generateId(2)"
                        title="grade-linha"
                        placeholder="grade-linha"
                        :value="img.gradeLinha"
                        :options="imagesSelectsContent[i].gradeLinhaSelect"
                        :loading="imagesSelectsContent[i].gradeLinhaLoading"
                        @search="(e) => loadGradeLinhas(i, e)"
                        @input="(e) => updateGradeLinhas(i, e)"
                        label="nome"
                        tooltipLabel="info-catalogo-grade-linha"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                        :disabled="!img.produto"
                        searchable
                        clearable
                    />
                </div>
                <div class="combo-box">
                    <vss-select
                        :id="generateId(3)"
                        title="item-pacote"
                        placeholder="item-pacote"
                        :value="img.pacote"
                        :options="imagesSelectsContent[i].pacoteSelect"
                        :loading="imagesSelectsContent[i].pacoteLoading"
                        @search="(e) => loadPacotes(i, e)"
                        @input="(e) => updatePacotes(i, e)"
                        label="nome"
                        tooltipLabel="info-catalogo-pacote"
                        tooltipPosition="is-top"
                        :disabled="!img.produto"
                        tooltipSize="is-small"
                        multiple
                        searchable
                        clearable
                        />
                </div>
                <div class="combo-box">
                    <vss-select
                        :id="generateId(4)"
                        title="destaque"
                        :value="img.destaque"
                        :options="destaqueSelect"
                        :invalid="img.destaque == null"
                        @input="(e) => updateDestaque(i, e)"
                        label="nome"
                        tooltipLabel="info-catalogo-destaque"
                        tooltipPosition="is-top"
                        tooltipSize="is-small"
                    />
                </div>
            </div>
            <div class="control-box">
                <b-button
                    class="mr-2"
                    type="is-danger"
                    icon-right="delete"
                    @click="canRemove(img)"
                    v-tippy
                    :title="$t('delete')"
                />
            </div>
        </div>
        <PaginationViewer
            class="mb-0 pagination"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />
    </div>
</template>

<script>
import VenProdutoService from '@/services/vendas/produto/VenProdutoService';
import PacoteKitService from '@/services/vendas/produto/PacoteKitService';
import GradeLinhaService from '@/services/vendas/produto/GradeLinhaService';

export default {
    props: {
        imageList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            produtoService: new VenProdutoService(this.$http, this.$router),
            pacoteKitService: new PacoteKitService(this.$http, this.$router),
            gradeLinhaService: new GradeLinhaService(this.$http, this.$router),
            produtoSelect: [],
            pageProdutoSelect: [],
            produtosFoundByName: [],
            produtoLoading: false,
            destaqueSelect: [
                { nome: this.$t('nao'), value: 0 },
                { nome: this.$t('sim'), value: 1 },
            ],
            images: [],
            imagesSelectsContent: [],
            imagesPaginated: [],
            imagesNameList: [],
            imageToRemove: {},
            canSave: false,
            antQuery: '',
            paginationProduto: {
                currentPage: 0,
                perPage: 40,
                totalResults: 0,
            },
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            firstLoad: true,
            empresas: [],
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-catalogo');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'catalogo' },
            });

        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.loadEmpresas();

        this.manipulateImageList();
        this.checkImageNameIsProductErp();
    },
    methods: {
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: `${e.id}` });
                });
            }
        },
        generateId(numberId) {
            return this.$route.name + '-lista-items-' + numberId;
        },
        manipulateImageList() {
            this.imageList.forEach((p) => {
                this.images.push({
                    fileName: p.fileName,
                    file: p.file,
                    id: p.id,
                    originalName: p.originalName,
                    url: p.url,
                    imgurl: p.imgurl,
                    produto: p.produto ? p.produto : null,
                    gradeLinha: p.gradeLinha ? p.gradeLinha : null,
                    pacote: p.pacote ? p.pacote : null,
                    destaque: p.destaque ? p.destaque : { nome: this.$t('nao'), value: 0 },
                    fileNameNoExtension: p.fileName.split('.')[0].trim(),
                });

                this.imagesSelectsContent.push({
                    gradeLinhaSelect: [],
                    gradeLinhaLoading: false,
                    // gradeLinhaDisabled: true,
                    pacoteSelect: [],
                    pacoteLoading: false,
                    // pacoteDisabled: true,
                });

                this.imagesNameList.push(p.fileName.split('.')[0].trim());
            });

            this.setPagingArray();
            this.validateCanSave();
            this.pagination.totalRows = this.images.length;

            this.$emit('photosUpdate', this.images, this.canSave);
        },

        // @87205 - necessario que a pesquisa por produto seja utilizada por todas as imagens
        loadProdutos(query) {
            this.produtoLoading = true;

            if (this.antQuery != query) {
                this.paginationProduto.currentPage = 0;
                this.antQuery = query;
            }

            this.produtoService
                .loadComboProdutosPaginado(
                    this.paginationProduto.currentPage,
                    this.paginationProduto.perPage,
                    query
                )
                .then(this.mapProdutos)
                .then((r) => {
                    this.pageProdutoSelect = r;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa. Termo: [${query}]`, e);
                })
                .finally((_) => {
                    this.paginationProduto.currentPage = this.paginationProduto.currentPage + 1;
                    this.produtoLoading = false;
                });
        },
        updateProdutos(position, e) {
            let pos = (this.pagination.currentPage - 1) * this.pagination.perPage + position;

            this.images[pos].produto = e;
            this.images[pos].gradeLinha = null;
            this.images[pos].pacote = null;

            this.loadGradeLinhas(position, '');
            this.loadPacotes(position, '');
            this.validateCanSave();

            this.$emit('photosUpdate', this.images, this.canSave);
        },
        checkImageNameIsProductErp() {
            let idempresas = this.$store.state.user.empresas.map((e) => {
                return e.id;
            });

            this.produtoService
                .loadComboProdutosByImageName(idempresas, this.imagesNameList)
                .then(this.mapNameFoundProducts)
                .then((r) => {
                    this.produtosFoundByName = r;
                    this.setNamedProductsFound();
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa.`, e);
                })
                .finally((_) => {
                    this.produtoLoading = false;
                    this.validateCanSave();
                    this.$emit('photosUpdate', this.images, this.canSave);
                });
        },
        mapProdutos(res) {
            this.paginationProduto.totalResults = res.totalElements;

            return res.content.map((r) => {
                return {
                    id: r.idproduto,
                    idproduto: r.idproduto,
                    nome: r.idprodutoerp + ' - ' + r.descricao,
                    idprodutoerp: r.idprodutoerp,
                    descricao: r.descricao,
                };
            });
        },
        setNamedProductsFound() {
            this.produtosFoundByName.forEach((x) => {
                if (this.firstLoad) {
                    this.images.every((y, i) => {
                        if (x.key == y.fileNameNoExtension) {
                            y.produto = x.value;
                            this.loadGradeLinhas(i, '');
                            this.loadPacotes(i, '');
                            return false;
                        }
                        return true;
                    });
                }
                this.produtoSelect.push(x.value);
            });

            this.firstLoad = false;
        },
        mapNameFoundProducts(body) {
            return body.content.map((r) => {
                return {
                    first: r.first,
                    key: r.key,
                    second: {
                        id: r.second.idproduto,
                        idproduto: r.second.idproduto,
                        nome: r.second.idprodutoerp + ' - ' + r.second.descricao,
                        idprodutoerp: r.second.idprodutoerp,
                        descricao: r.second.descricao,
                    },
                    value: {
                        id: r.second.idproduto,
                        idproduto: r.second.idproduto,
                        nome: r.second.idprodutoerp + ' - ' + r.second.descricao,
                        idprodutoerp: r.second.idprodutoerp,
                        descricao: r.second.descricao,
                    },
                };
            });
        },

        // Grade Linha
        loadGradeLinhas(position, q) {
            let pos = (this.pagination.currentPage - 1) * this.pagination.perPage + position;
            if (this.images[pos].produto) {
                this.imagesSelectsContent[pos].gradeLinhaLoading = true;
                this.gradeLinhaService
                    .findAllGradeLinhasByProdutoCombo(this.images[pos].produto.idproduto, 30, q)
                    .then(this.mapGradeLinhas)
                    .then((r) => {
                        this.imagesSelectsContent[pos].gradeLinhaSelect = r;
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa. Termo: [${q}]`, e);
                    })
                    .finally((_) => {
                        this.imagesSelectsContent[pos].gradeLinhaLoading = false;

                        if (
                            this.imagesSelectsContent[pos].gradeLinhaSelect &&
                            this.imagesSelectsContent[pos].gradeLinhaSelect.length == 1 &&
                            this.images[pos].gradeLinha == null
                        ) {
                            this.images[pos].gradeLinha = this.imagesSelectsContent[
                                pos
                            ].gradeLinhaSelect[0];
                        }
                    });
            }
        },
        updateGradeLinhas(position, e) {
            let pos = (this.pagination.currentPage - 1) * this.pagination.perPage + position;
            this.images[pos].gradeLinha = e;
            this.$emit('photosUpdate', this.images, this.canSave);
        },
        mapGradeLinhas(body) {
            return body.content.map((r) => {
                return {
                    id: r.idgradelinha,
                    nome: r.descricao,
                    idgradelinhaerp: r.idgradelinhaerp,
                    descricao: r.descricao,
                    idgrade: r.idgrade,
                };
            });
        },

        // Pacote
        loadPacotes(position, q) {
            let pos = (this.pagination.currentPage - 1) * this.pagination.perPage + position;
            if (this.images[pos].produto) {
                this.imagesSelectsContent[pos].pacoteLoading = true;
                this.pacoteKitService
                    .findAllPacotesByProduto(this.images[pos].produto.idproduto, 30, q)
                    .then(this.mapPacotes)
                    .then((r) => {
                        this.imagesSelectsContent[pos].pacoteSelect = r;
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa. Termo: [${q}]`, e);
                    })
                    .finally((_) => {
                        this.imagesSelectsContent[pos].pacoteLoading = false;

                        if (
                            this.imagesSelectsContent[pos].pacoteSelect &&
                            this.imagesSelectsContent[pos].pacoteSelect.length == 1 &&
                            this.images[pos].pacote == null
                        ) {
                            this.images[pos].pacote = this.imagesSelectsContent[
                                pos
                            ].pacoteSelect[0];
                        }
                    });
            }
        },
        updatePacotes(position, e) {
            let pos = (this.pagination.currentPage - 1) * this.pagination.perPage + position;
            this.images[pos].pacote = e;
            this.$emit('photosUpdate', this.images, this.canSave);
        },
        mapPacotes(body) {
            return body.content.map((r) => {
                return {
                    id: r.idpacote,
                    nome: r.descricao,
                    idpacoteerp: r.idpacoteerp,
                    descricao: r.descricao,
                };
            });
        },

        updateDestaque(position, e) {
            let pos = (this.pagination.currentPage - 1) * this.pagination.perPage + position;

            /* Percorre a lista e verifica se tem alguma outra imagem com o mesmo produto que tenha o campo destaque com valor 1 */
            if (e.value == this.destaqueSelect[1].value) {
                for (let i = 0; i < this.images.length; i++) {
                    if (
                        i != pos &&
                        this.images[pos].produto &&
                        this.images[i].produto &&
                        this.images[pos].produto.idproduto == this.images[i].produto.idproduto &&
                        this.images[i].destaque.value == this.destaqueSelect[1].value
                    ) {
                        this.$root.confirm({
                            message: this.$t('msg-catalogo-destaque-multiplo'),
                            onConfirm: () => {
                                this.images[i].destaque = this.destaqueSelect[0];
                                this.$emit('photosUpdate', this.images, this.canSave);
                            },
                            onCancel: () => {
                                this.images[pos].destaque = this.destaqueSelect[0];
                                this.$emit('photosUpdate', this.images, this.canSave);
                            },
                        });
                    }
                }
            }

            this.images[pos].destaque = e;
            this.validateCanSave();

            this.$emit('photosUpdate', this.images, this.canSave);
        },
        canRemove(img) {
            this.imageToRemove = img;

            this.$root.confirm({
                message: this.$t('msg-catalogo-remocao-imagem'),
                onConfirm: this.remove,
            });
        },
        remove() {
            let itemPosition = this.images.indexOf(this.imageToRemove);
            this.images.splice(itemPosition, 1);
            this.imagesSelectsContent.splice(itemPosition, 1);
            this.imageToRemove = {};

            this.setPagingArray();
            this.validateCanSave();

            this.$emit('photosUpdate', this.images, this.canSave);

            if (this.images.length == 0) {
                this.$emit('listEmpty');
            }
        },
        validateCanSave() {
            let count = 0;
            let totalImages = this.images.length;
            this.images.forEach((x) => {
                if (x.produto != null && x.destaque != null) {
                    count++;
                }
            });

            this.canSave = count == totalImages;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;

            this.setPagingArray();
        },
        setPagingArray() {
            this.imagesPaginated = this.images.slice(
                (this.pagination.currentPage - 1) * this.pagination.perPage,
                this.pagination.currentPage * this.pagination.perPage
            );
            this.pagination.totalRows = this.images.length;
        },
        // edit(){

        // }
    },
};
</script>

<style lang="scss" scoped>
.step-lista-imagem {
    display: flex;
    width: 100%;
    justify-content: center;
    padding: 20px 10px;
    border: 1px solid $table-border;
    flex-wrap: wrap;

    .pagination {
        width: 100%;
    }

    .photo-box {
        border-bottom: 3px solid $light-gray-color;
        margin-bottom: 20px;

        .image-box {
            flex-grow: 0;
            padding: 5px;

            .image-as-background {
                width: 150px;
                height: 150px;
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }
        }

        .extra-info-box {
            display: flex;
            flex-wrap: wrap;
            flex-grow: 1;
            justify-content: space-evenly;

            .combo-box {
                width: 49%;
                height: 70px;
                margin-bottom: -40px;
            }

            .combo-box:nth-child(3),
            .combo-box:nth-child(4) {
                margin-bottom: auto;
            }
        }

        .control-box {
            width: 100px;
            padding: 5px;
            display: flex;
            justify-content: center;
            align-items: center;

            > span {
                margin-top: auto;
                margin-left: auto;
                margin-right: 0 !important;
            }
        }
    }
}

.step-lista-imagem:last-child .combo-box {
    border-bottom: none;
}
</style>
